<template>
    <div class="not-found-container">
        <div class="content text-center">
            <h1 class="error-code">404</h1>
            <h2 class="error-message">{{ currentTranslation.title }}</h2>
            <p class="error-description">
                {{ currentTranslation.description }}
            </p>
            <router-link to="/" class="btn btn-primary">
                {{ currentTranslation.buttonName }}
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotFound',
    data() {
        return {
            language: localStorage.getItem('language') || 'uz',
            translations: {
                uz: {
                    title: "Sahifa topilmadi",
                    description: "Kechirasiz, siz qidirgan sahifa mavjud emas yoki olib tashlangan bo'lishi mumkin.",
                    buttonName: "Bosh sahifaga qaytish",
                },
                en: {
                    title: "Page not found",
                    description: "Sorry, the page you are looking for does not exist or may have been removed.",
                    buttonName: "Return to main page",
                },
                ru: {
                    title: "Страница не найдена",
                    description: "Извините, страница, которую вы ищете, не существует или, возможно, была удалена.",
                    buttonName: "Вернуться на домашнюю страницу",
                }
            }
        };
    },
    computed: {
        currentTranslation() {
            return this.translations[this.language] || this.translations.uz;
        }
    }
}
</script>

<style scoped>
.not-found-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background-color: #f8f9fa;
    padding: 20px;
}

.content {
    max-width: 600px;
    padding: 2rem;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.error-code {
    font-size: 6rem;
    font-weight: bold;
    color: #6c757d; /* Navbar'dagi faol rang */
    margin-bottom: 1rem;
    transition: color 0.3s ease;
}

.error-message {
    font-size: 2rem;
    color: #343a40;
    margin-bottom: 1rem;
}

.error-description {
    font-size: 1.1rem;
    color: #6c757d;
    margin-bottom: 2rem;
}

.btn-primary {
    display: inline-block;
    padding: 0.75rem 1.5rem;
    font-size: 1rem;
    color: #fff;
    background-color: #6c757d; /* Navbar'dagi faol rang */
    border: none;
    border-radius: 5px;
    text-decoration: none;
    transition: background-color 0.3s ease, transform 0.3s ease;
}

.btn-primary:hover {
    background-color: #e9ecef; /* Navbar'dagi hover rangi */
    color: #343a40;
    transform: translateY(-2px);
}

.btn-primary:active {
    transform: translateY(0);
}

@media (max-width: 576px) {
    .error-code {
        font-size: 4rem;
    }

    .error-message {
        font-size: 1.5rem;
    }

    .error-description {
        font-size: 1rem;
    }

    .btn-primary {
        padding: 0.5rem 1rem;
        font-size: 0.9rem;
    }
}
</style>